import clsx from 'clsx';
import React from 'react';

import { INPUT_VARIANTS } from '../../utils/constants';

interface Props extends React.PropsWithChildren {
    variant?: keyof typeof INPUT_VARIANTS;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    onClick?: () => void;
    wrapperClassName?: string;
}

export const Chip: React.FC<Props> = (props) => {
    const {
        variant = 'blue_text_white_bg',
        leftIcon,
        rightIcon,
        onClick,
        children,
        wrapperClassName
    } = props;

    return (
        <span
            className={clsx(
                "w-fit flex justify-center items-center gap-1 px-1 xl:px-2 rounded border",
                INPUT_VARIANTS[variant],
                wrapperClassName
            )}
        >
            {leftIcon}
            <span
                role='button'
                className={clsx(
                    'font-semibold text-sm xl:text-base',
                    onClick && 'cursor-pointer'
                )}
                onClick={onClick}
            >
                {children}
            </span>
            {rightIcon}
        </span>
    )
}